import React from 'react';
import { Loading, ActivityIndicator } from 'zarm';

const StaticLoading = {
  show: () => {
    Loading.show({
      content: <ActivityIndicator />,
    });
  },
  hide: () => {
    Loading.hide();
  },
};

export default StaticLoading;
